<div id="page-modifications" class="copy-size-{{accessArrangements.fontSize}} colour-contrast-{{accessArrangements.contrast}}">
  <ng-content></ng-content>
</div>
